// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UX47","footer":"styles_footer__2Ctd5"};